import axios from "axios";
import { apiRest } from "./constants";
const api = axios.create({ baseURL: apiRest, withCredentials: true });
const request = async (action) => {
  try {
    return (await action()).data;
  } catch (error) {
    return {
      error: true,
      message:
        typeof error.response?.data?.message === "string"
          ? error.response.data.message
          : "No se pudo completar la operación. Comprueba la conexión y reintenta.",
    };
  }
};
export const listTpvCustomers = (params) =>
  request(() => api.get("customer-picker", { params }));
export const createTpvCustomer = (data) =>
  request(() => api.post("customers", data));
export const assignTpvCartCustomer = (id, data) =>
  request(() => api.patch(`shopping-cart/${id}/customer`, data));
